"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutButton = void 0;
const React = require("react");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const retailOrderingRoutes_1 = require("../../../../../../apps/spg/ordering/components/RetailOrderingApp/retailOrderingRoutes");
const useRequiredContext_1 = require("../../../../../../hooks/useRequiredContext");
const RetailEventTrackingContext_1 = require("../../../contexts/RetailEventTrackingContext");
const SalesOrderContext_1 = require("../../../contexts/SalesOrderContext");
const RetailLocationsContext_1 = require("../../../contexts/RetailLocationsContext");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const Currency_1 = require("../../../../../../components/base/atoms/Currency");
const useRetailLocationDeliveryDetails_1 = require("../../../hooks/useRetailLocationDeliveryDetails");
const useRetailLocationAvailability_1 = require("../../../hooks/useRetailLocationAvailability");
const OrderTypeContext_1 = require("../../../contexts/OrderTypeContext");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CheckoutButton");
const CheckoutButton = ({}) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { salesOrderItems, totalPrice } = (0, react_1.useContext)(SalesOrderContext_1.SalesOrderContext);
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { logViewCart } = (0, useRequiredContext_1.useRequiredContext)(RetailEventTrackingContext_1.RetailEventTrackingContext);
    const { orderType } = (0, react_1.useContext)(OrderTypeContext_1.OrderTypeContext);
    const { minimumDeliveryAmount, maximumOrderValue } = retailLocation;
    const { hasFulfilledMinimumDeliveryAmount, showMinimumAmountMsg } = (0, useRetailLocationDeliveryDetails_1.useRetailLocationDeliveryDetails)(retailLocation);
    const { hasFulfilledMaximumOrderValue, showMaximumAmountMsg } = (0, useRetailLocationAvailability_1.useRetailLocationMaximumOrderValueCheck)(retailLocation);
    return (React.createElement("div", { className: css("") },
        (showMinimumAmountMsg || showMaximumAmountMsg) && (React.createElement("div", { className: css("minimumAmount") },
            showMinimumAmountMsg && (React.createElement("h4", null,
                "Minimum order amount:",
                " ",
                React.createElement(Currency_1.Currency, null, minimumDeliveryAmount))),
            showMaximumAmountMsg && (React.createElement("h4", null,
                "Maximum order amount: ",
                React.createElement(Currency_1.Currency, null, maximumOrderValue))),
            orderType === "delivery" && React.createElement("span", null, "(Excluding delivery and service fees)"))),
        React.createElement(Button_1.BlockButton, { className: css("button"), disabled: !hasFulfilledMinimumDeliveryAmount || !hasFulfilledMaximumOrderValue, onClick: () => {
                history.push(retailOrderingRoutes_1.retailOrderingPaths.cart, history.location.pathname);
                // send analytic event that the customer is viewing their cart
                logViewCart(salesOrderItems, totalPrice);
            } }, "checkout")));
};
exports.CheckoutButton = CheckoutButton;
//# sourceMappingURL=index.js.map